/**
 * Feature flags for controlling visibility of incomplete features
 * Set to true when feature is ready for production
 */
export const FEATURES = {
  // Operations Module
  HOUSEKEEPING_ENABLED: false,
  INSPECTIONS_ENABLED: true,
  MAINTENANCE_ENABLED: false,
  STORAGE_LOCATIONS_ENABLED: true,
  STORAGE_ITEMS_ENABLED: true,
  MANAGE_STOCK_ENABLED: true,
  STOCK_MOVEMENTS_ENABLED: true,
  CLEANING_STANDARDS_ENABLED: true,
  PROPERTY_SETUP_ENABLED: true,
  CHECKLISTS_ENABLED: true,

  // Main Dashboard Cards
  WORK_ORDERS_MAIN_DASHBOARD_ENABLED: false,

  // Ops Dashboard Cards
  WORK_ORDERS_OPS_DASHBOARD_ENABLED: true,

};

export default FEATURES;